import { F_MapMarkerWallFragment } from '__generated__v2/graphql';
import { EmptyLayer } from 'pages/special/OsloDesignFair/map/markers/view/EmptyLayer';
import { WallSegment } from 'pages/special/OsloDesignFair/map/markers/view/WallMarker/WallSegment';
import { RefObject } from 'react';
import { MapRef } from 'react-map-gl';

interface Props {
    mapRef: RefObject<MapRef | null>;
    marker: F_MapMarkerWallFragment;
    beforeId?: string;
    orderIndex: number;
}

export const PolygonWall = (props: Props): JSX.Element => {
    const { marker } = props;

    const layerIds = {
        layer: marker.id + '|layer',
        last: marker.id + '|last'
    };

    const beforeIds = {
        layer: props.beforeId,
        last: layerIds.layer
    };

    const closedCoordinates = [
        ...marker.transformedCoordinates,
        marker.transformedCoordinates[0]
    ].filter(Boolean);

    return (
        <>
            <WallSegment
                sourceId={marker.id}
                layerId={layerIds.layer}
                beforeId={beforeIds.layer}
                markerData={[
                    {
                        coordinates: closedCoordinates,
                        wallProps: {
                            color: marker.fillColor,
                            height: marker.fillHeight,
                            baseHeight: marker.fillBaseHeight
                        },
                        markerId: marker.id,
                        selectable: marker.selectable ?? false,

                        orderIndex: props.orderIndex,
                        visible: !marker.isHidden
                    }
                ]}
                opacity={marker.fillOpacity}
            />
            <EmptyLayer id={layerIds.last} beforeId={beforeIds.last} />
        </>
    );
};
